import { KEYWORD } from "../_constants/actionConstants";
import axios from "axios";
import { BASE_URL } from "../_constants/urlConstants";
import raiseError from "./raiseError";

const add = (newKeywordData) => async (dispatch) => {
  dispatch({ type: KEYWORD.ADD });
  const apiEndpoint = `${BASE_URL}/api/Project/${newKeywordData.projectId}/Keyword`;
  try {
    const res = await axios.post(apiEndpoint, newKeywordData);
    if (res.data.message) {
      raiseWarning(KEYWORD.ADD_REJECTED, res.data.message);
      dispatch({ type: KEYWORD.ADD_REJECTED });
    }
    dispatch({ type: KEYWORD.ADD_FULFILLED });
  } catch (err) {
    raiseError(KEYWORD.ADD_REJECTED, err.response.data);
  }
};

const update = (updatedKeyword) => async (dispatch) => {
  dispatch({ type: KEYWORD.EDIT });
  const apiEndpoint = `${BASE_URL}/api/Project/${updatedKeyword.projectId}/Keyword`;
  try {
    const res = await axios.put(apiEndpoint, updatedKeyword);
    if (res.data.message) {
      raiseWarning(KEYWORD.EDIT_REJECTED, res.data.message);
      dispatch({ type: KEYWORD.EDIT_REJECTED });
    }
    dispatch({ type: KEYWORD.EDIT_FULFILLED });
  } catch (err) {
    raiseError(KEYWORD.EDIT_REJECTED, err.response.data);
  }
};

const deleteKeyword = (keywordId, projectId) => async (dispatch) => {
  dispatch({ type: KEYWORD.DELETE });
  const apiEndpoint = `${BASE_URL}/api/Project/${projectId}/Keyword/${keywordId}`;
  try {
    const res = await axios.delete(apiEndpoint);
    if (res.data.message) {
      raiseWarning(KEYWORD.DELETE_REJECTED, res.data.message);
      dispatch({ type: KEYWORD.DELETE_REJECTED });
    }
    dispatch({ type: KEYWORD.DELETE_FULFILLED });
    dispatch({ type: KEYWORD.CLEAR_DETAILS, keywordId, projectId });
  } catch (err) {
    raiseError(KEYWORD.DELETE_REJECTED, err.response.data);
  }
};

const hasLinks = (projId, kwId) => async (dispatch) => {
  dispatch({ type: KEYWORD.GENERIC_REQUEST });
  const apiEndpoint = `${BASE_URL}/api/Project/${projId}/Keyword/${kwId}/HasLinks`;
  try {
    const res = await axios.get(apiEndpoint);
    dispatch({ type: KEYWORD.GENERIC_REQUEST_FULFILLED });
    return res.data;
  } catch (err) {
    raiseError(KEYWORD.GENERIC_REQUEST_REJECTED, err.response.data);
  }
};

const getAll = (projectId) => async (dispatch) => {
  dispatch({ type: KEYWORD.FETCH_ALL_FOR_PROJECT });
  const apiEndpoint = `${BASE_URL}/api/Project/${projectId}/Keyword/List`;
  try {
    const res = await axios.get(apiEndpoint);
    dispatch({
      type: KEYWORD.FETCH_ALL_FOR_PROJECT_FULFILLED,
      projKeywordList: res.data,
      projectId,
    });
  } catch (err) {
    raiseError(KEYWORD.FETCH_ALL_FOR_PROJECT_REJECTED, err.response.data);
  }
};

const getDetails = (keywordId, projectId) => async (dispatch) => {
  dispatch({ type: KEYWORD.FETCH_DETAILS });
  const apiEndpoint = `${BASE_URL}/api/Project/${projectId}/Keyword/${keywordId}`;
  try {
    const res = await axios.get(apiEndpoint);
    dispatch({
      type: KEYWORD.FETCH_DETAILS_FULFILLED,
      keywordDetails: res.data,
      keywordId,
      projectId,
    });
  } catch (err) {
    raiseError(KEYWORD.FETCH_DETAILS_REJECTED, err.response.data);
  }
};

const keywordActions = {
  add,
  deleteKeyword,
  getAll,
  getDetails,
  hasLinks,
  update,
};

export default keywordActions;
